module.exports = __webpack_public_path__ + "media/images/flags/in-e5926cb75dcbb15638dae2af4b9abbcc.svg";